<div class="mx-auto mb-6">

    <!-- MOBILE: 2 righe da 3 -->
    <div class="grid grid-cols-3 sm:hidden text-center">
      <ng-container *ngFor="let label of steps; let i = index">
        <div
          class="py-2 border-b-4 font-bold transition-colors"
          [ngClass]="{
            'border-blue-900 text-blue-900': step === i + 1,
            'border-gray-300 text-gray-500': step !== i + 1
          }"
        >
          {{ label }}
        </div>
      </ng-container>
    </div>

    <!-- DESKTOP: una riga orizzontale -->
    <div class="hidden sm:flex w-full text-center">
      <div
        *ngFor="let label of steps; let i = index"
        class="flex-1 py-2 border-b-4 font-bold transition-colors"
        [ngClass]="{
          'border-blue-900 text-blue-900': step === i + 1,
          'border-gray-300 text-gray-500': step !== i + 1
        }"
      >
        {{ label }}
      </div>
    </div>
    
</div>

<div class="mx-auto 2xl:max-w-screen-2xl p-6">

  <!-- Step dinamico -->
  <app-step1 *ngIf="step === 1" (avanti)="avantiStep()"></app-step1>
  <app-step2 *ngIf="step === 2" (avanti)="avantiStep()"></app-step2>
  <app-step3 *ngIf="step === 3" (avanti)="avantiStep()"></app-step3>
  <app-step4 *ngIf="step === 4" (avanti)="avantiStep()"></app-step4>
  <app-step5 *ngIf="step === 5" (avanti)="avantiStep()"></app-step5>
  <app-step6 *ngIf="step === 6" (avanti)="avantiStep()"></app-step6>

  <!-- Contenuto dinamico -->
  <ng-content></ng-content>

  <div class="pt-8 text-right">
    <small *ngIf="referralCode" class="text-xs text-gray-500">
      Ref: {{ referralCode }}
    </small>
  </div>

</div>


